import dayJs from "dayjs";
import { events } from "../../../scripts/constants";
import { EventEmitter, showElement, trackCheckoutEvent } from "../../../utils";
import { hideBasketAlertBox, showBasketAlertBox } from "../alerts";
import { hideBasketNotificationBar } from "../alerts/hideBasketNotificationBar";
import { reportError } from "../basket-v2/errorReporting";
import { constants } from "../common";
import setBasketRemainingTime from "./setBasketRemainingTime";

let basketExpiryTimer: number | undefined = null;
let raisedBasketExpiryEvent: boolean = false;
const currentURL: string = window.location.href;

export function setBasketExpiryTimer(expiryDate: dayJs.Dayjs, checkoutUrl?: string, delay: number = 300000) {
  // @ts-ignore
  window.basketExpiryTime = expiryDate;
  raisedBasketExpiryEvent = false;

  if (!document.querySelector(constants.selectors.basketAlert)) {
    return;
  }

  const basketExpiryBar = document.querySelector(constants.selectors.basketExpiryNotice);

  if (!!basketExpiryTimer) {
    clearInterval(basketExpiryTimer);
  }

  setBasketRemainingTime(expiryDate);

  basketExpiryTimer = self.setInterval(function () {
    const now = dayJs();
    var diffMs = expiryDate.diff(now, "millisecond");

    if (diffMs <= 0) {
      clearInterval(basketExpiryTimer);
      basketExpiryTimer = null;

      hideBasketAlertBox();
      hideBasketNotificationBar();
      window.localStorage.removeItem(constants.defaults.basketAlertLocalStorageKey);

      reportError("ar", "Your basket has expired.");

      trackCheckoutEvent({
        message_name: "basket_timeout_occurred",
        message_type: "warning",
        checkout_step: "basket",
      });

      // redirect in checkout
      if (currentURL.includes("checkout")) {
        window.location.href = checkoutUrl;
      }

      // redirect in basket
      if (currentURL.includes("basket")) {
        const basketUrl = new URL(window.location.href);
        basketUrl.searchParams.set("status", "expired");
        window.location.href = basketUrl.toString();
      }

      return;
    } else if (diffMs <= delay) {
      showBasketAlertBox({
        message: "<strong>WARNING</strong>",
        delay: "none",
        style: "time-warning",
        checkoutUrl,
        onClosed: () => {
          window.localStorage.setItem(constants.defaults.basketAlertLocalStorageKey, "true");

          if (!basketExpiryBar) {
            clearInterval(basketExpiryTimer);
            basketExpiryTimer = null;
          } else {
            showElement(basketExpiryBar);
          }

          const timeWarning = document.querySelector(constants.selectors.timeWarning);
          if (timeWarning) {
            timeWarning.remove();
          }
        },
      });

      if (!raisedBasketExpiryEvent) {
        trackCheckoutEvent({
          message_name: "basket_timeout_popup",
          message_type: "warning",
          checkout_step: "basket",
        });
        raisedBasketExpiryEvent = true;
      }
    }

    setBasketRemainingTime(expiryDate);
  }, 1000);
}

EventEmitter.on(
  events.SET_BASKET_EXPIRY_TIMER,
  ({ expiryDate, checkoutUrl, delay }: { expiryDate: dayJs.Dayjs; checkoutUrl?: string; delay?: number }) => {
    setBasketExpiryTimer(expiryDate, checkoutUrl, delay);
  }
);
